import styled from '@emotion/styled';

export const CardSubscriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.sm};
`;

export const CardSubscriptionTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CardSubscriptionTopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const CardSubscriptionBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;

export const CardSubscriptionBottomLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const CardSubscriptionBottomLeftItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xs};
`;
